import React from 'react';
import styled from 'styled-components';
import { FadeLoader } from 'react-spinners';

import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import { Video } from '../../../components/common/atom/Video';
import { Paragraph } from '../../../components/common/atom/Paragraph';
import { DownloadButton } from '../../../components/common/molecules/DownloadButton';

import * as api from '../../../lib/api/api';
import ThemeStyle from '../../../lib/style/ThemeStyle';
import { ERROR_RETRY } from '../../../lib/Error';
import { BABYFACE_URL } from '../../../lib/routes/Routes';

const FinalProductView = ({ data: { imageList, videoList } }) => {
  return (
    <>
      {imageList.map((finalImage) => {
        return (
          <FinalProductImage finalImage={finalImage} key={finalImage.id} />
        );
      })}
      {videoList.map((video, idx) => (
        <FinalProductVideo
          key={video.id}
          finalVideo={video}
          poster={imageList[idx].storageUri}
        />
      ))}
    </>
  );
};

export default React.memo(FinalProductView);

const Image = styled.img`
  width: 100%;
  object-fit: contain;
  margin-bottom: 0.5rem;
  border-radius: 6px;
`;

export const FinalProductVideo = ({
  finalVideo: { id, url, status },
  poster,
}) => {
  const downloadVideo = () => {
    window.location.href = `${BABYFACE_URL}/final-product/video/${id}`;
  };

  if (status === 'COMPLETED') {
    return (
      <Flex column>
        <Video
          src={url}
          poster={poster}
          style={{
            maxWidth: '288px',
            maxHeight: '385px',
          }}
        />
        <DownloadButton type="video" eventHandler={downloadVideo} />
        <Text size={12} color="orangePink" style={{ marginTop: '0.625rem' }}>
          * 베이비페이스 4D는 현재 베타 버전으로, 수정이 불가한 점 양해
          부탁드립니다.
        </Text>
      </Flex>
    );
  }
  if (status === 'PENDING') {
    return (
      <Flex
        column
        padding="1.25rem"
        height="24rem"
        style={{
          maxHeight: '385px',
        }}
      >
        <FadeLoader color={ThemeStyle.color.orangePink} />
        <Paragraph align="center">
          <Text size={12}>
            분석된 얼굴을 바탕으로
            <br /> 베이비페이스 4D 동영상을 생성중입니다.
            <br />
            완성되면 알림톡을 보내드립니다.
          </Text>
        </Paragraph>
      </Flex>
    );
  }
};

const FinalProductImage = ({ finalImage: { id, storageUri } }) => {
  // 임시
  const handleDownloadImage = () => {
    api
      .getImage({ id })
      .then((response) => {
        const htmlBlob = new Blob([response.data], {
          type: 'image/png',
        });
        const url = URL.createObjectURL(htmlBlob);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = '';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      })
      .catch(() => alert(ERROR_RETRY));
  };

  return (
    <Flex column>
      <Image src={storageUri} />
      <DownloadButton type="image" eventHandler={handleDownloadImage} />
    </Flex>
  );
};
